import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loadingcomponent from "../loader/loadingcomponent";
import { getGlobalSettingValue } from "../../services/common/utils";

const BottomModalComponent = (props) => {
  const { t } = useTranslation()
  const toggleModal = props.togglebottomModal;
  const evtconfirmClick = props.confirmclick;
  const type = props.popuptype;
  const loading = props?.loading;
  const success = props?.success;
  const cancelClick = props?.cancelClick
  const { shouldEnableBackdropClick = 'static' } = props;

  const closeModal = () => {
    // console.log(`close modal...`);
    toggleModal();
  };

  const confirmClick = () => {
    evtconfirmClick();
  };


  if (type == 'confirm') {
    return (
      <Modal show={props.show} onHide={closeModal} className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div>
          <p className="modal_p">{props.message}</p>
          <div className='flex_grp_align_center'>
            <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2"
             onClick={closeModal}>{t("cancel")}</button>
            <button type="button" className="custom_btn custom_btn_primary btn_block ms-2"
             onClick={confirmClick}>{t("confirm")}</button>
          </div>

        </Modal.Body>
      </Modal>
    );
  }

  if (type == 'fail') {
    return (
      <Modal show={props.show} backdrop={shouldEnableBackdropClick} onHide={() => { closeModal() }} className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div>
          <p className="modal_p">{props.respmessage}</p>
          <div className='flex_grp_align_center'>
            <button type="button" className={`custom_btn ${props?.showOk ? 'custom_btn_primary' : 'custom_btn_primary_outline'} btn_block me-2`} onClick={closeModal}> {props?.showOk ? t('okuper') : t("cancel")}</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  if (type == 'success') {
    return (
      <Modal show={props.show} backdrop={shouldEnableBackdropClick} onHide={() => { closeModal() }} className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div>
          <p className="modal_p">{props.respmessage}</p>
          <div className='flex_grp_align_center'>
            <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2" onClick={closeModal}>{t("okuper")}</button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  if (type == 'nojoom-confirm') {
    return (
      <Modal show={props.show} onHide={toggleModal} className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div>
          <p className="modal_p">{props.message}</p>
          <div className='flex_grp_align_center'>
            <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2" onClick={cancelClick}>{t("cancel")}</button>
            <button type="button" className="custom_btn custom_btn_primary btn_block ms-2" onClick={confirmClick}>{t("confirm")}</button>
          </div>

        </Modal.Body>
      </Modal>
    );
  }

  if (type == 'deleteaccount') {
    return (
      <Modal show={props.show} backdrop="static" className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">

        <Modal.Header className="border-0 flex_grp_center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title="" />
          </div>
        </Modal.Header>
        <Modal.Body>
          <h6 className="text-center">{t("BeforeYouProceed")}</h6>

          <div class="d-flex align-items-center justify-content-between mt-2">
            <div>{t("pnt")}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div>{t("aldwd")}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div>{t("rypmtbd")}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div>{t("wpycal")}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div>{t("yspd")}</div>
          </div>

          <p className="modal_p">{props.message}</p>
          <div className='flex_grp_align_center'>
            <button type="button" className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={closeModal}>{t("cancel")}</button>
            <button type="button" className={`custom_btn custom_btn_primary btn_block ms-2 ${loading ? "disabled" : ""
              }`}
              onClick={loading ? () => { } : confirmClick}>
              {loading ? <Loadingcomponent></Loadingcomponent> : t("confirmsubmit")}

            </button>
          </div>

        </Modal.Body>
      </Modal>
    );
  }

  //recent puchase home exception on card click
  if(type === "info"){
    return ( <Modal show={props.show} onHide={closeModal}  backdrop="true" className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect">

    <Modal.Header className="border-0 flex_grp_center">
      <div className="modal_img ">
        <img
          src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
          width={60}
          alt=""
          title="" />
      </div>
    </Modal.Header>
    <Modal.Body className="text-center">
    <p className="modal_p">{getGlobalSettingValue('offer_not_purchasable') || t('offer_not_purchasable')}</p>
    <button type="button" className={`custom_btn custom_btn_primary btn_block ms-2 `} onClick={props.togglebottomModal}>
      {t('okuper') }
    </button>
    </Modal.Body>
  </Modal>
    )
  }


};
export default BottomModalComponent;
